import { Group } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { valueToThemeColor } from "../utils"
import { LIKERT_VARIANTS } from "./constants"
import classes from "./Question.module.css"
import { ButtonQuestion } from "./QuestionButton"
import type { TQuestionProps } from "./types"

export function QuestionLikert({ question, setValue, value, preview }: TQuestionProps) {
  const variant = LIKERT_VARIANTS[question.meta?.category] || LIKERT_VARIANTS.yes
  const { t } = useTranslation()

  return (
    <Group gap="xs">
      {(variant as any[]).map((v) => (
        <ButtonQuestion
          key={v.value}
          preview={preview}
          classNames={classes}
          style={{ "--color-hover": `var(--mantine-color-${valueToThemeColor(v.value)}-5)` }}
          onClick={() => setValue(v.value)}
          variant={value === v.value ? "filled" : "outline"}
          color={value == v.value ? valueToThemeColor(v.value) : "gray"}
        >
          {t(v.label)}
        </ButtonQuestion>
      ))}
    </Group>
  )
}
